import { c as _c } from "react/compiler-runtime";
// Section Components for consistent UI across seller unit pages

interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
}
export function SectionTitle(t0) {
  const $ = _c(5);
  const {
    children,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `py-2.5 border-b border-secondary-600 ${className}`;
  let t3;
  if ($[0] !== children) {
    t3 = <h2 className="text-lg font-semibold text-secondary-600">{children}</h2>;
    $[0] = children;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
interface SectionContentProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
}
export function SectionContent(t0) {
  const $ = _c(8);
  const {
    children,
    className: t1,
    title
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `p-4 ${className}`;
  let t3;
  if ($[0] !== title) {
    t3 = title && <SectionTitle>{title}</SectionTitle>;
    $[0] = title;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children) {
    t4 = <div className="mt-3">{children}</div>;
    $[2] = children;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}